const extra = (t: any) => [];

export const enum MODULES {
  ASSIST = 'assist',
  BUG_REPORTS = 'bug-reports',
  OFFLINE_RECORDINGS = 'offline-recordings',
  ALERTS = 'alerts',
  ASSIST_STATS = 'assist-stats',
  RECOMMENDATIONS = 'recommendations',
}

export default extra;
